import React, { useState } from "react";
import { Link } from "react-router";
import Layout from "../../../Layouts/Layout";
import Container from "../../../../components/Container/Container";
import LegalbirdLoader from "../../../../components/ContentLoader/LegalbirdLoader";
import { getCaseLink, getProductData } from "../../../../services/productService";
import { Helmet } from "react-helmet-async";
import { apiCall } from "../../../../services/apiClient";
import HintBox from "../../../../components/Box/HintBox/HintBox";
import { fromGender } from "../../../../services/formServiceFunctions";
import Button from "@mui/material/Button";
import { STATUS_POWER_OF_ATTORNEY_GRANTED } from "../../../../services/divorce/leadStatus";
import PowerOfAttorney from "../../../../components/Form/Divorce/PowerOfAttorney";
import { FormProvider } from "../../../../provider/Form/FormProvider";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { fetchResource, queryKeys } from "../../../../services/reactQuery/reactQueryService";
import useProductParams from "../../../../hooks/useProductParams";
import { useCustomer } from "../../../../provider/Customer/CustomerProvider";

const PowerOfAttorneyPageDivorce = () => {
  const { productId } = useProductParams();
  const [isLoadingInternal, setIsLoadingInternal] = useState(false);
  const [isComplete, setIsComplete] = useState(false);
  const productApiUri = getProductData("divorce", "apiUri");
  const { data: divorce, isLoading } = useQuery({
    queryKey: queryKeys.item(productApiUri, productId),
    queryFn: () => fetchResource(productApiUri, productId)
  });
  const { customer } = useCustomer();
  const formService = getProductData("divorce", "formService");
  const queryClient = useQueryClient();

  if (isLoading) {
    return (
      <Layout>
        <Container sx={{ width: 250 }}>
          <LegalbirdLoader />
        </Container>
      </Layout>
    );
  }

  if (isComplete || divorce <= STATUS_POWER_OF_ATTORNEY_GRANTED || divorce.powerOfAttorney !== null) {
    return (
      <Layout>
        <Container>
          <HintBox headline={"Vielen Dank!"}>
            <p>Wir haben Ihre Vollmacht gespeichert und bearbeiten Ihre Scheidung entsprechend weiter.</p>
            <Button variant={"text"} color={"primary"} component={Link} to={getCaseLink(divorce)} fullWidth>
              Zurück zur Scheidung
            </Button>
          </HintBox>
        </Container>
      </Layout>
    );
  }

  const handleSubmit = async () => {
    setIsLoadingInternal(true);
    await apiCall("PATCH", "/divorces/" + divorce.id + "/power_of_attorney", {
      body: JSON.stringify({
        powerOfAttorney: null,
      }),
    });
    setIsLoadingInternal(false);
    setIsComplete(true);
    queryClient.invalidateQueries({
      queryKey: ["/divorces", productId],
    });
  };

  return (
    <FormProvider initialValues={formService.prepareFormData(divorce, customer)} submitAction={handleSubmit}>
      <Layout>
        <Helmet>
          <title>Vollmacht | Legalbird</title>
        </Helmet>
        <Container>
          <HintBox headline={"Bitte erteilen Sie Ihre Vollmacht"}>
            <p>
              Achtung: Auf dieser Vollmacht muss{" "}
              <strong>
                {fromGender(divorce.client.gender)} {divorce.client.givenName} {divorce.client.familyName}
              </strong>{" "}
              unterzeichnen damit wir weiter tätig werden können.
            </p>
          </HintBox>
          <PowerOfAttorney product={divorce} submitProps={{ isLoading: isLoadingInternal, isMinimal: true }} />
        </Container>
      </Layout>
    </FormProvider>
  );
};
export default PowerOfAttorneyPageDivorce;
